export default {
    name: 'thumbtack-rating',
    props: ['rating']
};
